module.exports = __webpack_public_path__ + "static/media/infoIcon.1dfb6b52.svg";